import angular from 'angular';

/**
 * @ngdoc overview
 * @name commonModule.locale
 * @description
 * # commonModule.locale
 * Module for managing the common directives.
 */
const locale = angular.module('commonModule.locale', []);

/**
 * @ngdoc directive
 * @name commonModule.locale.directive:pluralTimes
 * @description
 * Directive for plural form of word 'times'
 */
locale.directive('pluralTimes', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            number: '=ngModel'
        },
        controller: ['$scope', '$translate', function ($scope, $translate) {
            $scope.$watch('number', function (value) {
                if (angular.isDefined(value) && value > 1) {
                    $scope.timesText = $translate.instant('TIMES');
                } else {
                    $scope.timesText = $translate.instant('TIME');
                }
            });
        }],
        template: '{{timesText}}'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.locale.directive:pluralMinutes
 * @description
 * Directive for plural form of word 'minutes'
 */
locale.directive('pluralMinutes', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            number: '=ngModel'
        },
        controller: ['$scope', '$translate', function ($scope, $translate) {
            $scope.$watch('number', function (value) {
                switch (value) {
                    case 1:
                        $scope.minutesText = $translate.instant('MINUTE');
                        break;
                    case 2:
                    case 3:
                    case 4:
                        $scope.minutesText = $translate.instant('MINUTE_TWO_AND_MORE');
                        break;
                    default:
                        $scope.minutesText = $translate.instant('MINUTES');
                        break;
                }
            });
        }],
        template: '{{minutesText}}'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.locale.directive:pluralBeacons
 * @description
 * Directive for plural form of word 'beacons'
 */
locale.directive('pluralBeacons', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            number: '=ngModel'
        },
        controller: ['$scope', '$translate', function ($scope, $translate) {
            $scope.$watch('number', function (value) {
                switch (value) {
                    case 1:
                        $scope.beaconsText = $translate.instant('BEACON');
                        break;
                    case 2:
                    case 3:
                    case 4:
                        $scope.beaconsText = $translate.instant('BEACON_TWO_AND_MORE');
                        break;
                    default:
                        $scope.beaconsText = $translate.instant('BEACONS');
                        break;
                }
            });
        }],
        template: '{{beaconsText}}'
    };
});

export default locale;
